import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgGroup1363 = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <rect
      width={15.289}
      height={15.289}
      x={1}
      y={5.113}
      stroke={props.color ? props.color : "#494949"}
      strokeWidth={2}
      rx={1}
    />
    <rect
      width={15.289}
      height={15.289}
      x={5.401}
      y={1.026}
      fill="#fff"
      stroke={props.color ? props.color : "#494949"}
      strokeWidth={2}
      rx={1}
    />
    <g clipPath="url(#Group_1363_svg__a)">
      <path
        fill="#494949"
        d="M17.695 9.47h-3.85v3.851H12.56v-3.85h-3.85V8.186h3.85V4.336h1.284v3.85h3.85z"
      />
    </g>
    <defs>
      <clipPath id="Group_1363_svg__a">
        <path fill="#fff" d="M5.501 1.127h15.403V16.53H5.501z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGroup1363;
